<template>
    <el-dialog class="dialog-order-info" title="时间预设" :visible.sync="dialogVisible" width="25%">
        <el-form class="g-form-grid" ref="form" :model="form" label-width="120px" :rules="rules">
            <el-form-item label="初始化天数 :" prop="day">
                <el-input v-model="form.day" placeholder="请输入" :disabled="pageType === 'detail'"></el-input>
            </el-form-item>

            <el-form-item label="开始预约时间 :" prop="beginTime">
                <el-date-picker type="datetime" placeholder="选择日期" v-model="form.beginTime"
                    style="width: 100%;"></el-date-picker>
            </el-form-item>

            <el-form-item label="停止预约时间 :" prop="endTime">
                <el-date-picker type="datetime" placeholder="选择日期" v-model="form.endTime"
                    style="width: 100%;"></el-date-picker>
            </el-form-item>
        </el-form>

        <div slot="footer" class="footer mt-30">
            <el-button @click="cancel">取消</el-button>
            <el-button @click="submit" type="primary" :loading="loadingSave">确定</el-button>
        </div>
    </el-dialog>
</template>

<script>
export default {
    data() {
        return {
            dialogVisible: false,
            form: {
                day: '',
                beginTime: '',
                endTime: ''
            },
            pageType: '',
            rules: {
                day: [
                    { required: true, message: '天数不能为空', trigger: 'blur' }
                ],
                beginTime: [
                    { required: true, message: '开始预约时间不能为空', trigger: 'blur' }
                ],
                endTime: [
                    { required: true, message: '停止预约时间不能为空', trigger: 'blur' }
                ]
            },
            listQuery: {
                currentPage: 1,
                size: 10
            },
            loadingSave: true,
        }
    },
    methods: {
        init() {
            this.dialogVisible = true
            // this.getData()
        },

        getData() {
            this.listLoading = true
            this.tableData = []
            this.$api.applet.getDigitalExhibitionList({
                ...this.listQuery
            }).then(res => {
                this.listLoading = false
                if (res.success) {
                    if (res.result && res.result.records) {
                        this.tableData = res.result.records
                        this.total = res.result.total
                    }
                } else {
                    this.$message.error(res.message)
                }
            })
        },

        cancel(){
            this.$refs['form'].resetFields()
            this.dialogVisible = false
        },

        submit(){}
    }
}
</script>

<style lang="scss" scoped>
</style>